<ng-template>
  <div (click)="onSelect()" class="dropdown-content">
    <ng-content></ng-content>
  </div>
</ng-template>
